<template>
  <div
    :class="['HorizontalBtnGroup', { alignCenter: variant.align === 'center' }]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  data () {
    return {};
  },
  props: {
    variant: {
      type: Object,
      default: () => ({}),
    },
  },
  created () {},
  components: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.HorizontalBtnGroup {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.alignCenter {
  justify-content: center;
}
</style>
